import styled, { css } from 'styled-components';

export const WrapperFilterButtons = styled.div<{ isMobile?: boolean }>`
  ${({ isMobile = false }) => css`
    ${isMobile &&
    css`
      overflow-x: auto;
      padding: 10px 5px;
    `}

    ::-webkit-scrollbar {
      width: 1px;
      opacity: 0;
    }

    ::-webkit-scrollbar-thumb {
      opacity: 0;
    }
  `}
`;
